import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { colors, fontMono, s } from "../lib/theme";

export default function SuperAdmin() {
  const [tab, setTab] = useState("usuarios");

  return (
    <div style={s.page}>
      <h1 style={s.h1}>Superadministración</h1>
      <p style={s.subtitle}>Usuarios y clubs de toda la plataforma.</p>

      <div style={{ display: "flex", gap: 8, margin: "18px 0", borderBottom: `1px solid ${colors.line}` }}>
        <TabBtn active={tab === "usuarios"} onClick={() => setTab("usuarios")}>Usuarios</TabBtn>
        <TabBtn active={tab === "clubs"} onClick={() => setTab("clubs")}>Clubs</TabBtn>
        <TabBtn active={tab === "debug"} onClick={() => setTab("debug")}>Depurador de sesiones</TabBtn>
      </div>

      {tab === "usuarios" && <UsersTab />}
      {tab === "clubs" && <ClubsTab />}
      {tab === "debug" && <DebugLogTab />}
    </div>
  );
}

function TabBtn({ active, onClick, children }) {
  return (
    <button onClick={onClick} style={{
      background: "transparent", border: "none", borderBottom: `2px solid ${active ? colors.amber : "transparent"}`,
      color: active ? colors.text : colors.textDim, fontFamily: "inherit", fontSize: 14.5, fontWeight: 600,
      padding: "10px 6px", cursor: "pointer",
    }}>
      {children}
    </button>
  );
}

function UsersTab() {
  const [users, setUsers] = useState(null);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({ callsign: "", name: "", email: "", isSuperadmin: false });
  const [creating, setCreating] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const load = () => api.listUsers().then(setUsers).catch((err) => setError(err.message));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.createUser(form);
      setForm({ callsign: "", name: "", email: "", isSuperadmin: false });
      setCreating(false);
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <p style={{ color: colors.textDim, margin: 0, fontSize: 14 }}>Todos los indicativos dados de alta.</p>
        <button onClick={() => setCreating((v) => !v)} style={s.btnPrimary}>+ Nuevo usuario</button>
      </div>

      {creating && (
        <form onSubmit={submit} style={{ ...s.card, display: "flex", flexDirection: "column", gap: 12, marginBottom: 16 }}>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-end" }}>
            <Field label="INDICATIVO" value={form.callsign} onChange={(v) => setForm({ ...form, callsign: v.toUpperCase() })} width={140} />
            <Field label="NOMBRE" value={form.name} onChange={(v) => setForm({ ...form, name: v })} width={200} />
            <Field label="EMAIL" value={form.email} onChange={(v) => setForm({ ...form, email: v })} width={220} type="email" />
            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: colors.textDim, paddingBottom: 10 }}>
              <input type="checkbox" checked={form.isSuperadmin} onChange={(e) => setForm({ ...form, isSuperadmin: e.target.checked })} />
              Superadmin
            </label>
            <button type="submit" style={s.btnPrimary}>Crear</button>
          </div>
          <p style={{ fontSize: 12, color: colors.textFaint, margin: 0 }}>
            No hace falta poner contraseña: se manda un email a esa dirección con un enlace para que el propio usuario defina la suya.
          </p>
        </form>
      )}

      {error && <div style={s.errorBox}>{error}</div>}

      <div style={{ ...s.card, padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["Indicativo", "Nombre", "Email", "Rol", "Estado", "Clubs", ""].map((h) => (
                <th key={h} style={{ textAlign: "left", fontSize: 11, color: colors.textFaint, fontWeight: 700, padding: "10px 16px", background: colors.panelRaised, borderBottom: `1px solid ${colors.lineStrong}` }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users?.map((u) => (
              <tr key={u.id}>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a", fontFamily: fontMono, fontWeight: 700 }}>{u.callsign}</td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>{u.name}</td>
                <td style={{ fontSize: 13, padding: "10px 16px", borderBottom: "1px solid #16202a", color: colors.textDim }}>
                  {u.email || "—"}
                  {u.pending_setup && (
                    <span style={{ marginLeft: 6, fontSize: 10.5, fontWeight: 700, color: colors.amber }}>pendiente de definir contraseña</span>
                  )}
                </td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>{u.is_superadmin ? "Superadmin" : "Usuario"}</td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>
                  <span style={{
                    fontSize: 11.5, fontWeight: 700, borderRadius: 5, padding: "3px 9px",
                    color: u.is_active ? colors.green : "#ffb4b4",
                    background: u.is_active ? "#0f2a1c" : "#2a1214",
                    border: `1px solid ${u.is_active ? "#1c4a30" : "#7a2c2c"}`,
                  }}>
                    {u.is_active ? "Activo" : "Deshabilitado"}
                  </span>
                </td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>
                  {(u.clubs || []).map((c) => `${c.club_name}${c.role === "admin" ? " (admin)" : ""}`).join(", ") || "—"}
                </td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a", textAlign: "right", whiteSpace: "nowrap" }}>
                  <button onClick={() => setEditingUser(u)} style={{ background: "transparent", border: `1px solid ${colors.lineStrong}`, color: colors.amber, borderRadius: 5, fontSize: 11.5, fontWeight: 700, padding: "5px 10px", cursor: "pointer", marginRight: 6 }}>
                    Editar
                  </button>
                  <button
                    onClick={async () => {
                      const verb = u.is_active ? "deshabilitar" : "habilitar";
                      if (!window.confirm(`¿Seguro que quieres ${verb} a ${u.callsign}?`)) return;
                      try {
                        await api.updateUser(u.id, { isActive: !u.is_active });
                        load();
                      } catch (err) {
                        setError(err.message);
                      }
                    }}
                    style={{ background: "transparent", border: `1px solid ${colors.lineStrong}`, color: colors.textDim, borderRadius: 5, fontSize: 11.5, fontWeight: 700, padding: "5px 10px", cursor: "pointer", marginRight: 6 }}
                  >
                    {u.is_active ? "Deshabilitar" : "Habilitar"}
                  </button>
                  <button
                    onClick={async () => {
                      if (!window.confirm(`¿Eliminar el usuario ${u.callsign}? Esta acción no se puede deshacer.`)) return;
                      try {
                        await api.deleteUser(u.id);
                        load();
                      } catch (err) {
                        setError(err.message);
                      }
                    }}
                    style={{ background: "transparent", border: "1px solid #7a2c2c", color: "#ffb4b4", borderRadius: 5, fontSize: 11.5, fontWeight: 700, padding: "5px 10px", cursor: "pointer" }}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p style={{ fontSize: 12, color: colors.textFaint, marginTop: 10 }}>
        El rol de "admin de club" (organizador) no se asigna aquí — se hace desde el panel de <b>Organizador → Miembros del club</b>, eligiendo el rol al añadir o promocionar a alguien ya en el club.
      </p>

      {editingUser && (
        <EditUserModal
          user={editingUser}
          onClose={() => setEditingUser(null)}
          onSaved={() => { setEditingUser(null); load(); }}
        />
      )}
    </div>
  );
}

function EditUserModal({ user, onClose, onSaved }) {
  const [name, setName] = useState(user.name || "");
  const [email, setEmail] = useState(user.email || "");
  const [isSuperadmin, setIsSuperadmin] = useState(!!user.is_superadmin);
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      await api.updateUser(user.id, { name, email, isSuperadmin });
      if (newPassword.trim()) {
        await api.resetPassword(user.id, newPassword.trim());
      }
      onSaved();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
      <div style={{ width: 380, background: colors.panelRaised, border: `1px solid ${colors.lineStrong}`, borderRadius: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", borderBottom: `1px solid ${colors.line}` }}>
          <span style={{ fontSize: 15.5, fontWeight: 700, color: colors.text, fontFamily: fontMono }}>{user.callsign}</span>
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: colors.textDim, cursor: "pointer", fontSize: 16 }}>✕</button>
        </div>
        <div style={{ padding: "18px 22px" }}>
          <div style={{ marginBottom: 14 }}>
            <label style={s.label}>NOMBRE</label>
            <input style={s.input} value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={s.label}>EMAIL</label>
            <input style={s.input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: colors.textDim, marginBottom: 16 }}>
            <input type="checkbox" checked={isSuperadmin} onChange={(e) => setIsSuperadmin(e.target.checked)} />
            Superadministrador
          </label>
          <div style={{ marginBottom: 4 }}>
            <label style={s.label}>NUEVA CONTRASEÑA (OPCIONAL)</label>
            <input style={s.input} type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Déjalo en blanco para no cambiarla" />
          </div>
          {error && <div style={{ ...s.errorBox, marginTop: 14 }}>{error}</div>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
            <button onClick={onClose} style={{ background: "transparent", border: `1px solid ${colors.lineStrong}`, color: colors.textDim, borderRadius: 6, fontWeight: 700, fontSize: 13, padding: "9px 16px", cursor: "pointer" }}>Cancelar</button>
            <button onClick={save} disabled={saving} style={{ ...s.btnPrimary, opacity: saving ? 0.6 : 1 }}>{saving ? "Guardando…" : "Guardar cambios"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ClubsTab() {
  const [clubs, setClubs] = useState(null);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);

  const load = () => api.listClubs().then(setClubs).catch((err) => setError(err.message));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.createClub({ name });
      setName("");
      setCreating(false);
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const removeClub = async (club) => {
    if (!window.confirm(`¿Eliminar el club "${club.name}"? Esta acción no se puede deshacer.`)) return;
    setError(null);
    try {
      await api.deleteClub(club.id);
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <p style={{ color: colors.textDim, margin: 0, fontSize: 14 }}>Cada club agrupa a sus operadores.</p>
        <button onClick={() => setCreating((v) => !v)} style={s.btnPrimary}>+ Nuevo club</button>
      </div>

      {creating && (
        <form onSubmit={submit} style={{ ...s.card, display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 16 }}>
          <Field label="NOMBRE DEL CLUB" value={name} onChange={setName} width={260} />
          <button type="submit" style={s.btnPrimary}>Crear</button>
        </form>
      )}

      {error && <div style={s.errorBox}>{error}</div>}

      <div style={{ ...s.card, padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["Club", "Miembros", "Admins", ""].map((h) => (
                <th key={h} style={{ textAlign: "left", fontSize: 11, color: colors.textFaint, fontWeight: 700, padding: "10px 16px", background: colors.panelRaised, borderBottom: `1px solid ${colors.lineStrong}` }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {clubs?.map((c) => (
              <tr key={c.id}>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>{c.name}</td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>{c.member_count}</td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a" }}>{(c.admins || []).join(", ") || "—"}</td>
                <td style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a", textAlign: "right" }}>
                  <button
                    onClick={() => removeClub(c)}
                    style={{ background: "transparent", border: "1px solid #7a2c2c", color: "#ffb4b4", borderRadius: 5, fontSize: 11.5, fontWeight: 700, padding: "5px 10px", cursor: "pointer" }}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, width, type = "text" }) {
  return (
    <div style={{ width }}>
      <label style={s.label}>{label}</label>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} style={s.input} />
    </div>
  );
}

function Table({ headers, rows }) {
  return (
    <div style={{ border: `1px solid ${colors.line}`, borderRadius: 10, overflow: "hidden" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h} style={{ textAlign: "left", fontSize: 11, color: colors.textFaint, fontWeight: 700, padding: "10px 16px", background: colors.panelRaised, borderBottom: `1px solid ${colors.lineStrong}` }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows?.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} style={{ fontSize: 13.5, padding: "10px 16px", borderBottom: "1px solid #16202a", fontFamily: j === 0 ? fontMono : "inherit", fontWeight: j === 0 ? 700 : 400 }}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const EVENT_COLORS = {
  claim_cell: colors.green,
  set_frequency: colors.amber,
  qso_created: "#7dd3fc",
  publish_cluster: "#c084fc",
};

function DebugLogTab() {
  const [entries, setEntries] = useState(null);
  const [callsignFilter, setCallsignFilter] = useState("");
  const [error, setError] = useState(null);

  const load = (cs) => {
    api.getDebugLog(cs).then(setEntries).catch((err) => setError(err.message));
  };

  useEffect(() => { load(); }, []);

  return (
    <div>
      <p style={{ fontSize: 12.5, color: colors.textFaint, marginBottom: 12 }}>
        Lo que ha mandado cada sesión (Gateway o web) tal cual, para depurar sin depender de capturas de pantalla —
        se guarda 7 días, hasta 300 eventos más recientes.
      </p>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        <input
          value={callsignFilter}
          onChange={(e) => setCallsignFilter(e.target.value)}
          placeholder="Filtrar por indicativo (opcional)"
          style={{ ...s.input, maxWidth: 260 }}
        />
        <button onClick={() => load(callsignFilter)} style={s.btnGhost}>Filtrar</button>
        <button onClick={() => { setCallsignFilter(""); load(); }} style={s.btnGhost}>Ver todo</button>
      </div>

      {error && <div style={s.errorBox}>{error}</div>}
      {!entries && !error && <p style={{ color: colors.textFaint, fontSize: 13 }}>Cargando…</p>}
      {entries?.length === 0 && <p style={{ color: colors.textFaint, fontSize: 13 }}>Sin eventos todavía.</p>}

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {entries?.map((e) => (
          <div key={e.id} style={{
            border: `1px solid ${colors.lineStrong}`, borderRadius: 6, padding: "8px 12px", background: colors.panel,
          }}>
            <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 4 }}>
              <span style={{
                fontSize: 10.5, fontWeight: 700, padding: "2px 7px", borderRadius: 4,
                color: "#0a0e13", background: EVENT_COLORS[e.event_type] || colors.textDim,
              }}>
                {e.event_type}
              </span>
              <span style={{ fontFamily: fontMono, fontSize: 12.5, fontWeight: 700, color: colors.text }}>{e.callsign || "—"}</span>
              <span style={{ fontSize: 11, color: colors.textFaint }}>{new Date(e.created_at).toISOString().replace("T", " ").slice(0, 19)} UTC</span>
            </div>
            <pre style={{
              margin: 0, fontFamily: fontMono, fontSize: 11.5, color: colors.textDim,
              whiteSpace: "pre-wrap", wordBreak: "break-word",
            }}>
              {JSON.stringify(e.payload, null, 0)}
            </pre>
          </div>
        ))}
      </div>
    </div>
  );
}
